import gql from "graphql-tag";

export const LOGIN_QUERY = gql`
  mutation LoginMutation($email: String!, $password: String!) {
    login(user: $email, password: $password) {
      token
    }
  }
`;



// WEBPACK FOOTER //
// ./src/screens/Login/LoginForm/queries.ts